import * as React from 'react'

import _ from 'lodash'

import { observer } from 'mobx-react'

import ListEmployees from 'modules/core/components/ListEmployees'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import FiltersForm from 'modules/core/lib/forms/Filters'
import { normalizeText } from 'modules/core/lib/stringUtils'
import { employeeUser } from 'modules/core/store/collections/users'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import { locationActiveEmployees } from 'modules/locations/lib/locationEmployees'
import type Location from 'modules/locations/store/models/Location'

import Item from './Item'

interface Props {
  location: Location
  contractVersions: ContractVersions
}

const LocationEmployees = ({ location, contractVersions }: Props) => {
  const filtersForm = useLazyRef(() => new FiltersForm({})).current

  const locationEmployees = _.sortBy(locationActiveEmployees(location, employees), (employee) =>
    normalizeText(employeeUser(employee).fullName())
  )

  const renderEmployeeListItem = (employee: Employee) => {
    return <Item key={employee.id} employee={employee} location={location} />
  }

  return (
    <ListEmployees
      employees={locationEmployees}
      filtersForm={filtersForm}
      renderEmployeeListItem={renderEmployeeListItem}
      contractVersions={contractVersions}
    />
  )
}

export default observer(LocationEmployees)
